import Caret from '@clearkit/icons/glyphs/Caret';
import startCase from 'lodash/startCase';

import Tooltip from '~/components/Tooltip';

import AttributeValue from './AttributeValue';
import styles from './styles';

const Attribute = ({ attribute, showAttribute, classes }) => {
  const [open, setOpen] = useState(false);

  if (!showAttribute(attribute)) return null;

  const { label, value, tooltip, children } = attribute;
  return (
    <>
      <div
        key={label}
        className={classnames(
          classes.label,
          'flex flex-row justify-start py-1',
        )}>
        <div
          className={classnames(
            'flex flex-row flex-shrink-0 mr-4 items-center text-xs',
          )}
          style={{ width: '30%' }}>
          {children && (
            <div className="flex-shrink-0 mr-1 text-gray-500">
              <Caret
                onClick={() => setOpen(!open)}
                className={classnames(
                  'cursor-pointer transform',
                  open ? 'rotate-0' : '-rotate-90',
                )}
              />
            </div>
          )}
          {startCase(label)}

          {tooltip && (
            <Tooltip hovered title={tooltip}>
              ?
            </Tooltip>
          )}
        </div>
        <div className={classes.value}>
          <AttributeValue label={label} value={value} />
        </div>
      </div>

      {open &&
        children?.map((child) => (
          <Attribute
            attribute={child}
            showAttribute={showAttribute}
            classes={classes}
          />
        ))}
    </>
  );
};

Attribute.propTypes = {
  attribute: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  showAttribute: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(styles)(Attribute);
